import getApolloClient from './apolloClient'
import gql from 'graphql-tag'
import Vue from 'vue'
// import {
//   GraphQLEnumType,
// } from 'graphql'
// const TaskStateEnumType = new GraphQLEnumType({
//   name: 'TaskStateEnum',
//   values: {
//     ASSIGNED: {
//       value: 0,
//     },
//     IN: {
//       value: 1,
//     },
//   },
// })

const way = './graphql/releases/'

export default class ReleasesApi {
  async getReleases() {
    let releases = await import(way + 'releases.gql')
    return (await getApolloClient('/common'))
      .query({
        query: gql`${releases}`,
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async getReleasesSettings() {
    let releaseSettings = await import(way + 'releaseSettings.gql')
    return (await getApolloClient('/common'))
      .query({
        query: gql`${releaseSettings}`,
      })
      .catch(error => Vue.prototype.$log_error(error.message))
      .then(res => res?.data?.releaseSettings)
  }

  async setSignLastSeenRelease() {
    let signLastSeenRelease  = await import(way + 'signLastSeenRelease.gql')
    return (await getApolloClient('/common'))
      .mutate({
        mutation: gql`${ signLastSeenRelease }`,
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async deleteRelease( releaseId ) {
    let deleteRelease  = await import(way + 'deleteRelease.gql')
    return (await getApolloClient('/common'))
      .mutate({
        mutation: gql`${ deleteRelease }`,
        variables: {
          releaseId 
        }
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async deleteFeature( featureId ) {
    let deleteFeature  = await import(way + 'deleteFeature.gql')
    return (await getApolloClient('/common'))
      .mutate({
        mutation: gql`${ deleteFeature }`,
        variables: {
          featureId 
        }
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async createRelease( release ) {
    let createRelease  = await import(way + 'createRelease.gql')
    return (await getApolloClient('/common'))
      .mutate({
        mutation: gql`${ createRelease }`,
        variables: {
          release 
        }
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async createFeature( feature ) {
    let createFeature  = await import(way + 'createFeature.gql')
    return (await getApolloClient('/common'))
      .mutate({
        mutation: gql`${ createFeature }`,
        variables: {
          feature 
        }
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async changeReleaseNotificationOption( notify ) {
    let changeReleaseNotificationOption  = await import(way + 'changeReleaseNotificationOption.gql')
    return (await getApolloClient('/common'))
      .mutate({
        mutation: gql`${ changeReleaseNotificationOption }`,
        variables: {
          notify 
        }
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async changeRelease( release ) {
    // let item = {
    //   id: release.id ,
    //   dateTime: release.dateTime ,
    //   publishName: release.publishName ,
    //   gitName: release.gitName ,
    //   isPublished: release.isPublished ,
    // }
    let item = Object.assign({}, release)
    delete item.features
    delete item.__typename
    delete item.count
    let changeRelease  = await import(way + 'changeRelease.gql')
    return (await getApolloClient('/common'))
      .mutate({
        mutation: gql`${ changeRelease }`,
        variables: {
          release: item
        }
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async changeFeature( feature ) {
    // delete feature.number
    let changeFeature  = await import(way + 'changeFeature.gql')
    return (await getApolloClient('/common'))
      .mutate({
        mutation: gql`${ changeFeature }`,
        variables: {
          feature 
        }
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  
  async getFeaturesById( {id, releaseId, take, skip}) {
    let features = await import(way + 'features.gql')
    return (await getApolloClient('/common'))
      .query({
        query: gql`${features}`,
        variables: {
          id, releaseId, take, skip
        },
      
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }
    
  async getAllFeatures(payload) {
    let take = payload?.take,
      skip = payload?.skip,
      type = payload?.type
    let features = await import(way + 'allFeatures.gql')
    return (await getApolloClient('/common'))
      .query({
        query: gql`${features}`,
        variables: {
          type, take, skip
        },
      
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async getFeatureDetail() {
    let featureDetail = await import(way + 'featureDetail.gql')
    return (await getApolloClient('/common'))
      .query({
        query: gql`${featureDetail}`,
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }
}